<template>
    <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 class="text-xl font-bold mb-4 text-gray-800">Edit Client</h2>
        <form @submit.prevent="submitClient">
          <input v-model="localClient.name" class="w-full p-2 border rounded-lg mb-4" placeholder="Name" required />
          <input v-model="localClient.email" type="email" class="w-full p-2 border rounded-lg mb-4" placeholder="Email" required />
          <input v-model="localClient.phone" type="phone" class="w-full p-2 border rounded-lg mb-4" placeholder="Phone" required />
          <input v-model="localClient.address" type="address" class="w-full p-2 border rounded-lg mb-4" placeholder="Address" required />
          <button type="submit" class="w-full bg-green text-white p-2 rounded-lg">Update Client</button>
        </form>
        <button @click="closeModal" class="mt-4 w-full text-gray-600">Cancel</button>
      </div>
    </div>
  </template>
  
  <script>
import { mapActions } from 'vuex';

  export default {
    props: {
      client: {
      },
    },
    data() {
      return {
        localClient: { ...this.client}, // Create a local copy of the staff prop
      };
    },
    methods: {
      ...mapActions('clients',{updateClient : 'updateClient'}),
      submitClient() {
        this.$emit('editClient', this.localClient);
        this.updateClient(this.localClient);
        this.closeModal();
      },
      closeModal() {
        this.$emit('closeModal');
      },
    },
  };
  </script>
  